import { Typography } from "@material-ui/core";
import React from "react";
// import Progress from "react-progressbar";
import Rating from "@material-ui/lab/Rating";

export default ({ percent, header, imgSrc, class_ }) => (
  <div className={`skill-item ${class_.toLowerCase()}`}>
    <img src={imgSrc} alt="" />
    <div className="skill-item-description">
      <div className="skill-header">
        <div className="header">
          <Typography variant="body2">{header}</Typography>
        </div>
        {/* <div className="header description">
          <Typography variant="caption">{percent}%</Typography>
        </div> */}
      </div>
      <div className="description">
        {/* <Progress completed={percent} /> */}
        <Rating name="read-only" value={percent / 20} readOnly />
      </div>
    </div>
  </div>
);
